var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KTCard',{ref:"preview",attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"body",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }